module.exports = __webpack_public_path__ + "img/btransfer.77782086.svg";